import { Controller } from "@hotwired/stimulus"

const CSS_CLASSES = {
  isActive: "is--active"
}

export default class extends Controller {
  selectEpisode(event) {
    const item = event.currentTarget
    if (item.classList.contains(CSS_CLASSES.isActive)) { return }

    item.closest("form").requestSubmit()
  }
}
